import { ClientPluginInstance3k1rpw72h98wh as ClientPluginInstance } from './ClientPluginInstance.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { PrimitiveClasses_getInstance13wbaztpz3e2d as PrimitiveClasses_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  createKType31ecntyyaay3k as createKType,
  createKTypeParameter16gw97ll17xmd as createKTypeParameter,
  createInvariantKTypeProjection3h5364czc0a8w as createInvariantKTypeProjection,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function createClientPlugin(name, createConfiguration, body) {
  return new (ClientPluginImpl())(name, createConfiguration, body);
}
function createClientPlugin_0(name, body) {
  return createClientPlugin(name, createClientPlugin$lambda, body);
}
var ClientPluginImplClass;
function ClientPluginImpl() {
  if (ClientPluginImplClass === VOID) {
    class $ {
      constructor(name, createConfiguration, body) {
        this.c5w_1 = createConfiguration;
        this.d5w_1 = body;
        var tmp = this;
        // Inline function 'io.ktor.util.AttributeKey' call
        // Inline function 'io.ktor.util.reflect.typeInfo' call
        var tmp_0 = getKClass(ClientPluginInstance());
        var tmp_1 = null instanceof ClientPluginInstance();
        // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
        var tmp_2;
        try {
          tmp_2 = createKType(getKClass(ClientPluginInstance()), arrayOf([createInvariantKTypeProjection(createKType(createKTypeParameter('PluginConfigT', arrayOf([createKType(PrimitiveClasses_getInstance().vf(), arrayOf([]), false)]), 'invariant', false, 'io.ktor.client.plugins.api.ClientPluginImpl'), arrayOf([]), false))]), false);
        } catch ($p) {
          var tmp_3;
          if ($p instanceof Error) {
            var _unused_var__etf5q3 = $p;
            tmp_3 = null;
          } else {
            throw $p;
          }
          tmp_2 = tmp_3;
        }
        var tmp$ret$2 = tmp_2;
        var tmp$ret$1 = new (TypeInfo())(tmp_0, tmp_1, tmp$ret$2);
        tmp.e5w_1 = new (AttributeKey())(name, tmp$ret$1);
      }
      m3() {
        return this.e5w_1;
      }
      f5w(block) {
        // Inline function 'kotlin.apply' call
        var this_0 = this.c5w_1();
        block(this_0);
        var config = this_0;
        return new (ClientPluginInstance())(this.e5w_1, config, this.d5w_1);
      }
      o5l(block) {
        return this.f5w(block);
      }
      g5w(plugin, scope) {
        plugin.e5k(scope);
      }
      p5l(plugin, scope) {
        return this.g5w(plugin instanceof ClientPluginInstance() ? plugin : THROW_CCE(), scope);
      }
    }
    initMetadataForClass($, 'ClientPluginImpl');
    ClientPluginImplClass = $;
  }
  return ClientPluginImplClass;
}
function createClientPlugin$lambda() {
  return Unit_instance;
}
//region block: exports
export {
  createClientPlugin_0 as createClientPlugin16sdkdabbewya,
  createClientPlugin as createClientPluginjwpvufjows5r,
};
//endregion

//# sourceMappingURL=CreatePluginUtils.mjs.map
